import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  badgeText: string;
  bgColor?: string;
  backgroundImage?: string;
}
export function PageHeader({
  title,
  subtitle,
  badgeText,
  bgColor = 'bg-gradient-to-r from-primary to-secondary',
  backgroundImage
}: PageHeaderProps) {
  return <section className="relative pt-32 pb-20 overflow-hidden" data-id="element-274">
      {/* Background */}
      {backgroundImage ? <>
          <div className="absolute inset-0 z-0" data-id="element-275">
            <img src={backgroundImage} alt="" className="w-full h-full object-cover" loading="eager" width="1920" height="400" data-id="element-276" />
            <div className="absolute inset-0 bg-gradient-to-br from-charcoal/90 via-charcoal/80 to-charcoal/70" data-id="element-277" />
          </div>
        </> : <div className={`absolute inset-0 z-0 ${bgColor}`} data-id="element-278" />}

      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl" aria-hidden="true" data-id="element-279" />
      <div className="absolute bottom-10 left-10 w-80 h-80 bg-white/10 rounded-full blur-3xl" aria-hidden="true" data-id="element-280" />

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10" data-id="element-281">
        <div className="max-w-4xl mx-auto text-center" data-id="element-282">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-semibold mb-6 border border-white/30" data-id="element-283">
            {badgeText}
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-284">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto" data-id="element-285">
            {subtitle}
          </p>
        </div>
      </div>
    </section>;
}